var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c("skp-breadcrumbs", {
          attrs: { setMenuId: "LEFT_0000000073" },
          on: {
            "page-title": function(val) {
              return (_vm.pageTitle = val)
            }
          }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
        _vm._v(" "),
        !_vm.isLoading
          ? _c("div", { staticClass: "view_cont" }, [
              _c("div", { staticClass: "view_info" }, [
                typeof _vm.detail.PRD_CATEGORY_NM1 !== "undefined"
                  ? _c("div", { staticClass: "view_category" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.detail.PRD_CATEGORY_NM1) +
                          " \n                    "
                      ),
                      typeof _vm.detail.PRD_CATEGORY_NM2 !== "undefined"
                        ? _c("em", [_vm._v(">")])
                        : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(_vm.detail.PRD_CATEGORY_NM2) +
                          " \n                    "
                      ),
                      typeof _vm.detail.PRD_CATEGORY_NM3 !== "undefined"
                        ? _c("em", [_vm._v(">")])
                        : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(_vm.detail.PRD_CATEGORY_NM3) +
                          "\n                "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "icoBtn_wrap" }, [
                  _c(
                    "a",
                    {
                      staticClass: "ico_printer",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.printContents }
                    },
                    [
                      _c("span", { staticClass: "sr_only" }, [
                        _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.PRINT")))
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("dl", { staticClass: "view_subject" }, [
                _c("dt", { staticClass: "subject" }, [
                  _vm.detail.IMPORTANCE_YN === "Y"
                    ? _c("em", { staticClass: "textcolor_important" }, [
                        _vm._v(
                          "[" + _vm._s(_vm.$t("FIELD.GLOBAL.IMPORTANT")) + "]"
                        )
                      ])
                    : _vm.detail.MUST_READ_YN === "Y"
                    ? _c("em", { staticClass: "textcolor_must" }, [
                        _vm._v(
                          "[" + _vm._s(_vm.$t("FIELD.GLOBAL.MUSTREAD")) + "]"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm._f("refTitle")(_vm.detail.KNOWLEDGE_TITLE)) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "desc" }, [
                  _c("span", { staticClass: "desc_Regist" }, [
                    _c("em", [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.REGISTERED.BY")))
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.detail.REG_USER_NM) +
                        " (" +
                        _vm._s(_vm.detail.REG_DT) +
                        ")\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "desc_modify" }, [
                    _c("em", [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.MODIFY.USER")))
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.detail.MODF_USER_NM) +
                        " (" +
                        _vm._s(_vm.detail.MODF_DT) +
                        ")\n                    "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "view_desc" },
                [
                  _vm.isSCMS
                    ? _c("table", { staticClass: "data_table_ty2 mb-20" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("tbody", [
                          _c("tr", [
                            _c("th", { staticClass: "text_left" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SYMPTOM")))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm.symptomList.length === 0
                                  ? _c("ul", { staticClass: "in_dotlist" }, [
                                      _c("li", [_vm._v(" ")])
                                    ])
                                  : _vm._l(_vm.symptomList, function(symptom) {
                                      return _c(
                                        "ul",
                                        { staticClass: "in_dotlist" },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              _vm._s(symptom.C_CODE_T_INFO) +
                                                " > " +
                                                _vm._s(symptom.CODE_T_INFO)
                                            )
                                          ])
                                        ]
                                      )
                                    })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("th", { staticClass: "text_left" }, [
                              _vm._v(
                                _vm._s(_vm.$t("FIELD.KNOWLEDGE.MANUFACTURE"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm.serialList.length === 0
                                  ? _c("ul", { staticClass: "in_dotlist" }, [
                                      _c("li", [_vm._v(" ")])
                                    ])
                                  : _vm._l(_vm.serialList, function(serial) {
                                      return _c(
                                        "ul",
                                        { staticClass: "in_dotlist" },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              _vm._s(serial.SERIAL_S) +
                                                " ~ " +
                                                _vm._s(serial.SERIAL_E)
                                            )
                                          ])
                                        ]
                                      )
                                    })
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("th", { staticClass: "text_left" }, [
                              _vm._v(
                                _vm._s(_vm.$t("FIELD.KNOWLEDGE.GUIDETYPE"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(_vm.getGuideTypeName))]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text_left" }, [
                              _vm._v(
                                _vm._s(_vm.$t("FIELD.KNOWLEDGE.DEFECTTYPE"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(_vm.getDefectTypeName))])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "tab_wrap" }, [
                    _c("ul", { staticClass: "tab_menu_02 tab_menus" }, [
                      _c(
                        "li",
                        {
                          staticClass: "on",
                          on: {
                            click: function($event) {
                              return _vm.changeTab($event)
                            }
                          }
                        },
                        [
                          _c("a", { attrs: { href: "javascript:" } }, [
                            _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DESCRIPTION")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              return _vm.changeTab($event)
                            }
                          }
                        },
                        [
                          _c("a", { attrs: { href: "javascript:" } }, [
                            _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.MODEL.LIST")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              return _vm.changeTab($event)
                            }
                          }
                        },
                        [
                          _c("a", { attrs: { href: "javascript:" } }, [
                            _vm._v(_vm._s(_vm.$t("FIELD.KNOWLEDGE.PARTSLISTS")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              return _vm.changeTab($event)
                            }
                          }
                        },
                        [
                          _c("a", { attrs: { href: "javascript:" } }, [
                            _vm._v(_vm._s(_vm.$t("FIELD.KNOWLEDGE.VERHISTORY")))
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tab_contents" }, [
                      _c("div", {
                        staticClass: "tab_cont",
                        domProps: {
                          innerHTML: _vm._s(_vm.detail.KNOWLEDGE_DESC)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tab_cont" },
                        [
                          _c("toast-grid", {
                            ref: _vm.modelGridId,
                            attrs: {
                              gridId: _vm.modelGridId,
                              data: _vm.modelList,
                              columns: _vm.modelColumns,
                              options: _vm.options,
                              pageOptions: _vm.pageOptions,
                              isTotalCount: true
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tab_cont" },
                        [
                          _c("toast-grid", {
                            ref: _vm.partsGridId,
                            attrs: {
                              gridId: _vm.partsGridId,
                              data: _vm.partsList,
                              columns: _vm.partsColumns,
                              options: _vm.options,
                              pageOptions: _vm.pageOptions,
                              isTotalCount: true
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "tab_cont" }, [
                        _c("table", { staticClass: "data_table" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.VERSION")))
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "pc_only" }, [
                                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DATE")))
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "pc_only" }, [
                                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.EDITOR")))
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DETAILS")))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            { staticClass: "text_center" },
                            _vm._l(_vm.versionList, function(version, idx) {
                              return _vm.versionList.length > 0
                                ? _c("tr", [
                                    _c("td", [
                                      _vm._v(
                                        "Ver." + _vm._s(version.VERSION_NO)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "pc_only" }, [
                                      _vm._v(_vm._s(version.MODF_DT))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "pc_only" }, [
                                      _vm._v(_vm._s(version.MODF_USER))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text_left" }, [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(version.MODF_REASON) +
                                          "\n                                            "
                                      ),
                                      idx > 0
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "txt_link",
                                              attrs: { href: "javascript:" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.seeDetailPop(
                                                    version.KNOWLEDGE_ID,
                                                    version.VERSION_NO
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.KNOWLEDGE.SEE.DETAILS"
                                                    )
                                                  ) +
                                                  "\n                                            "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ])
                                : _vm._e()
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _vm.isReprocess
                          ? _c(
                              "div",
                              { staticClass: "btn_wrap text_right pt-10" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "txt_link",
                                    attrs: {
                                      href: "javascript:",
                                      title: _vm.$t(
                                        "FIELD.KNOWLEDGE.SEE.PREVIOUS"
                                      )
                                    },
                                    on: { click: _vm.seePrevPop }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("FIELD.KNOWLEDGE.SEE.PREVIOUS")
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.attach.length > 0
                    ? _c("innorix-download", {
                        attrs: {
                          uploadId: _vm.uploadId,
                          serviceType: _vm.serviceType,
                          attachList: _vm.attach
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.attach.length > 0
                    ? _c("dl", { staticClass: "attachment_link" }, [
                        _c("dt", [
                          _c(
                            "a",
                            {
                              staticClass: "txt_link",
                              attrs: { href: "javascript:" },
                              on: {
                                click: function($event) {
                                  return _vm.toggleLink($event)
                                }
                              }
                            },
                            [_vm._v("Having trouble downloading?")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "ul",
                            _vm._l(_vm.attach, function(file) {
                              return _c(
                                "li",
                                {
                                  key: file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "txt_link",
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.getDownloadUrl(
                                            file.ENC_ATTCH_FILE_SEQ,
                                            file.ENC_TOKEN
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "ico_attach" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(file.FILE_NM) +
                                          "\n                                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btn_wrap topLine" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white size_full",
                    attrs: {
                      href: "javascript:",
                      title: _vm.$t("BUTTON.GLOBAL.LIST")
                    },
                    on: { click: _vm.btnList }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.LIST")))]
                ),
                _vm._v(" "),
                _vm.btnAuth()
                  ? _c("div", { staticClass: "btn_right pc_only" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn_white",
                          attrs: {
                            href: "javascript:",
                            title: _vm.$t("BUTTON.GLOBAL.ADD.CONTENTS")
                          },
                          on: { click: _vm.btnAddContents }
                        },
                        [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.ADD.CONTENTS")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn_white",
                          attrs: {
                            href: "javascript:",
                            title: _vm.$t("BUTTON.GLOBAL.DELETE")
                          },
                          on: { click: _vm.btnDelete }
                        },
                        [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "30%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c76b2b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c76b2b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/myKnowledge/serviceScript/ServiceScriptDetail.vue
// module id = aEPZ
// module chunks = 0